// src/components/common/ChangePasswordModal.jsx
// Generic "change password" modal — works for players, admins and super admins.
import React, { useState } from 'react';
import './ChangePasswordModal.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

const ChangePasswordModal = ({ onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (newPassword.length < 8) { setError('New password must be at least 8 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE}/api/auth/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess('Password changed successfully');
        setTimeout(onClose, 1200);
      } else {
        setError(data.error || 'Failed to change password');
      }
    } catch (err) {
      setError('Cannot connect to server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-overlay" onClick={onClose}>
      <div className="cp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cp-header">
          <h3>🔒 Change Password</h3>
          <button type="button" className="cp-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="cp-error">{error}</div>}
          {success && <div className="cp-success">{success}</div>}
          <div className="cp-field">
            <label>Current password</label>
            <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required autoFocus />
          </div>
          <div className="cp-field">
            <label>New password</label>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="At least 8 characters" required />
          </div>
          <div className="cp-field">
            <label>Confirm new password</label>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
          </div>
          <div className="cp-actions">
            <button type="button" className="cp-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="cp-submit" disabled={loading}>{loading ? 'Changing…' : 'Change password'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
